import React, { useState } from "react";
import { useAuth } from "../store";
import { formatApiError } from "../api";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div
      className="dark fixed inset-0 flex items-center justify-center bg-black overflow-hidden"
      data-testid="admin-login-screen"
    >
      {/* Cinematic ambient — pure CSS, no external assets */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute -top-40 -left-40 w-[600px] h-[600px] rounded-full bg-red-500/[0.06] blur-3xl" />
        <div className="absolute top-1/2 -right-40 w-[500px] h-[500px] rounded-full bg-emerald-500/[0.05] blur-3xl" />
        <div
          className="absolute inset-0 opacity-[0.04]"
          style={{
            backgroundImage:
              "linear-gradient(hsl(0 0% 30%) 1px, transparent 1px), linear-gradient(90deg, hsl(0 0% 30%) 1px, transparent 1px)",
            backgroundSize: "48px 48px",
          }}
        />
      </div>
      <form
        onSubmit={submit}
        className="relative z-10 w-full max-w-sm bg-black/60 border border-white/10 backdrop-blur-xl p-8 space-y-6"
        data-testid="admin-login-form"
      >
        <div>
          <div className="font-display text-3xl font-medium text-white tracking-tight">
            Clipra
          </div>
          <div className="text-xs font-mono uppercase tracking-[0.25em] text-white/40 mt-1">
            // admin · v0.1
          </div>
        </div>

        <div className="space-y-3">
          <div>
            <label className="block text-xs font-mono uppercase tracking-[0.18em] text-white/50 mb-1.5">
              Email
            </label>
            <input
              type="email"
              autoFocus
              required
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-white/5 border border-white/10 px-3 py-2.5 text-sm text-white placeholder-white/30 focus:outline-none focus:border-white/40 transition-colors"
              placeholder="admin@clipra.pro"
              data-testid="admin-login-email"
            />
          </div>
          <div>
            <label className="block text-xs font-mono uppercase tracking-[0.18em] text-white/50 mb-1.5">
              Password
            </label>
            <input
              type="password"
              required
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-white/5 border border-white/10 px-3 py-2.5 text-sm text-white placeholder-white/30 focus:outline-none focus:border-white/40 transition-colors"
              placeholder="••••••••••"
              data-testid="admin-login-password"
            />
          </div>
        </div>

        {error && (
          <div
            className="text-sm text-red-400 border-l-2 border-red-500 pl-3 py-1 font-mono"
            data-testid="admin-login-error"
          >
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={busy}
          className="w-full bg-white text-black py-2.5 text-sm font-medium tracking-wide hover:bg-white/90 active:translate-y-px transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          data-testid="admin-login-submit"
        >
          {busy ? "Authenticating…" : "Sign in"}
        </button>

        <div className="text-center text-xs font-mono text-white/30">
          Authorized personnel only
        </div>
      </form>
    </div>
  );
}
